import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../Components/Atoms/CustomButton";
import { useFormik } from "formik";
import CustomSelect from "../../../../Components/Atoms/CustomSelect";
import CustomInput from "../../../../Components/Atoms/CustomInput";
import * as Yup from "yup";
import { useEffect } from "react";
import {
  postCustomRoleRequest,
  putCustomRoleRequest,
} from "../../../../Redux/Settings/SettingsActions";

const NewCustomRole = ({ handleClose, data }) => {
  const dispatch = useDispatch();
  const action = data ? "edit" : "new";
  const { postCustomRoleLoading } = useSelector(
    (state) => state.settingsReducer
  );

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      status: "ACTIVE",
    },
    onSubmit: (values) => {
      if (postCustomRoleLoading) return;
      if (action === "new") {
        dispatch(
          postCustomRoleRequest({
            ...values,
          })
        );
      } else {
        dispatch(
          putCustomRoleRequest({
            ...values,
            _id: data?._id,
          })
        );
      }
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Required"),
      status: Yup.string().required("Required"),
    }),
  });

  useEffect(() => {
    if (action === "edit") {
      Object.keys(formik.values).forEach((e) => {
        formik.setFieldValue(e, data[e]);
      });
    } else {
      formik.resetForm();
    }
  }, [data]);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <div className="d-flex">
              <p className="mb-1">Name</p>
              <p className="erroStar">*</p>
            </div>
            <CustomInput
              type="text"
              name="name"
              placeholder="Enter name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              formik={formik}
            />
          </div>
          <div className="col-md-6">
            <div className="d-flex">
              <p className="mb-1">Status</p>
              <p className="erroStar">*</p>
            </div>
            <CustomSelect
              type="text"
              name="status"
              placeholder="SELECT A STATUS"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.status}
              formik={formik}
              data={[
                { name: "ACTIVE", value: "ACTIVE" },
                { name: "INACTIVE", value: "INACTIVE" },
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex">
              <p className="mb-1">Description</p>
            </div>
            <CustomInput
              type="text"
              name="description"
              multiline
              rows={5}
              placeholder="Enter description"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.description}
              formik={formik}
            />
          </div>
        </div>
        <div className="btnActnBar">
          <CustomButton
            btnType="secondary"
            onClick={handleClose}
            label={"Cancel"}
            action={"CANCEL"}
          />
          <CustomButton
            label={postCustomRoleLoading ? "Loading..." : "Save"}
            type="submit"
            action={"SAVE"}
          />
        </div>
      </form>
    </>
  );
};

export default NewCustomRole;
